module.exports = __webpack_public_path__ + "static/media/p_violeta_tex.d5ad45f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/pez_v/p_violeta_tex.png
// module id = 144
// module chunks = 0